const styles = {
  select: {
    borderRadius: 4,
    backgroundColor: 'background.default',
    // '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
    //   border: 1,
    //   borderColor: (theme) => `${theme.palette.background.grey400}!important`,
    // },
    '& .MuiOutlinedInput-root': {
      minHeight: { xs: 48, lg: 40 },
    },
    '& .MuiInputLabel-shrink': {
      fontWeight: 600,
    },
    '& .MuiInputAdornment-root': {
      position: 'absolute',
      right: 35,
    },
  },
}

export default styles
